import React, {useEffect, useState} from "react";
import {useTheme} from "@mui/material/styles";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import {useNavigate} from "react-router-dom";
import MDBox from "components/MDBox";
import CancelIcon from "@mui/icons-material/Close";
import MDTypography from "components/MDTypography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Alert,
  AppBar,
  Card,
  Checkbox,
  FormControlLabel,
  Snackbar,
  InputLabel,
  Typography,
  MenuItem,
  Select,
  FormControl,
  Tooltip
} from "@mui/material";
import MDButton from "components/MDButton";
import {useLocation} from "react-router-dom";
import {DataGrid, GridActionsCellItem} from "@mui/x-data-grid";
//   React context
import {useMaterialUIController} from "context";
import {POST, DELETE, GET} from "APIclient";
import properties from "constants/ApplicationConstants";
import {formatDesignation} from "constants/ApplicationConstants";

function AddToRoaster(noGutter) {
  const [controller] = useMaterialUIController();
  const {darkMode} = controller;
  const location = useLocation();
  const [usersState, setUsersState] = useState(location.state);
  const theme = useTheme();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [snackbar, setSnackbar] = useState(null);
  const [snakColor, setSnakColor] = useState("");
  const [snakMessage, setSnakMessage] = useState("");
  const fetchUrl = `admin/employee/get-roster/${usersState}`;
  const viewUrl = `admin/get-salaries/${usersState}`;
  const [details, setDetails] = useState([]);
  const [data, setData] = useState([]);
  const [formData, setFormData] = useState({
    empId: "",
    masterTeam: "",
    subTeam: "",
    billableStatus: "",
    localite: ""
  });

  const [isSaveDisabled, setIsSaveDisabled] = useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await GET(fetchUrl);
        const data = response?.data?.data;
        setData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
    const view = async () => {
      try {
        const response = await GET(viewUrl);
        const view = response?.data?.data;
        setDetails(view);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    view();
  }, [fetchUrl, viewUrl]);
  const columns = [
    {field: "id", headerName: "ID", width: 100},
    {
      field: "empTeamName",
      headerName: "Master Team",
      width: 200
    },
    {
      field: "empSubTeamName",
      headerName: "Sub Team",
      width: 200
    },
    {
      field: "billableStatus",
      headerName: "Billable Status",
      valueGetter: (value, row) => (`${row.billableStatus}` == "1" ? "Billable" : "Non Billable"),
      width: 200
    },
    {
      field: "Remove",
      headerName: "Remove",
      width: 180,
      renderCell: params => {
        return [
          <GridActionsCellItem
            icon={
              <Tooltip title="Cancel" arrow>
                <CancelIcon />
              </Tooltip>
            }
            label="Remove"
            color="error"
            onClick={handleRemove(params)}
          />
        ];
      }
    }
  ];

  // const rows = [
  //     { id: 1, lastName: 'test', firstName: 'data', age: 'mn' },
  // ];

  const handleCloseSnackbar = () => setSnackbar(null);

  const handleChange = event => {
    const {name, value} = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleRemove = params => async () => {
    const removeUrl = `admin/delete-roster/${params.id}`;
    try {
      const response = await DELETE(removeUrl);
      // const data = response?.data?.data;
      //setData(data);// Initialize with fetched
      if (response?.data?.statusCode === 200) {
        setSnakColor("success");
        setSnakMessage("Removed successfully");
        setOpen(true);
        const fetchData = async () => {
          try {
            const response = await GET(fetchUrl);
            const data = response?.data?.data;
            setData(data);
          } catch (error) {
            // console.error("Error fetching data:", error);
            setSnakColor("error");
            setSnakMessage("Failed to add Roaster", error);
            setOpen(true);
          }
        };
        fetchData();
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSubmit = async () => {
    // Prepare the data to be sent to the server
    let data = {
      masterTeamId: formData.masterTeam,
      subTeamId: formData.subTeam,
      billableStatus: formData.billableStatus,
      localite: formData.localite
    };

    const url = `admin/employee/add-roster/${usersState}`;

    try {
      const response = await POST(url, data);
      if (response?.data?.statusCode === 200) {
        // Successfully updated
        setSnakColor("success");
        setSnakMessage("Add To Roaster successfully");
        setOpen(true);
        // Optionally navigate to another page after successful update
        const fetchData = async () => {
          try {
            const response = await GET(fetchUrl);
            const data = response?.data?.data;
            setData(data);
          } catch (error) {
            setSnakColor("error");
            setSnakMessage("Failed to add Roaster");
            setOpen(true);
            console.error("Error fetching data:", error);
          }
        };
        fetchData();

        formData.masterTeam = "";
        formData.subTeam = "";
        formData.billableStatus = "";
        formData.localite = "";
      } else {
        setSnakColor("error");
        setSnakMessage("Failed to add Roaster");
        setOpen(true);
      }
    } catch (error) {
      console.error("Error to add Roaster:", error);
      setSnakColor("error");
      setSnakMessage("Error to add Roaster");
      setOpen(true);
    }
  };

  useEffect(() => {
    const isFormValid =
      formData.masterTeam !== "" && formData.subTeam !== "" && formData.billableStatus !== "";
    setIsSaveDisabled(!isFormValid);
  }, [formData]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox container>
        <AppBar position="static">
          <Card>
            <MDBox
              pt={2}
              mb={0}
              pb={4}
              px={4}
              sx={{borderRadius: "5px", border: "1px solid #D3D3D3"}}
            >
              <MDBox px={2} mb={2}></MDBox>
              <MDBox
                component="li"
                display="flex"
                justifyContent="space-between"
                alignItems="flex-start"
                bgColor={darkMode ? "transparent" : "grey-100"}
                borderRadius="lg"
                p={1}
                // mb={noGutter ? 0 : 1}
                mt={1}
              >
                <MDBox width="100%" display="flex" flexDirection="column">
                  <Typography
                    variant="h6"
                    fontWeight="medium"
                    pb={2}
                    fontFamily={properties.fontFamily}
                  >
                    Official Details
                  </Typography>
                  <MDBox
                    display="flex"
                    justifyContent="space-between"
                    alignItems={{xs: "flex-start", sm: "center"}}
                    flexDirection={{xs: "column", sm: "row"}}
                    mb={1}
                  >
                    <MDBox mb={1} lineHeight={0}>
                      <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                        Emp ID :&nbsp;
                        <Typography
                          sx={{width: "150px", fontFamily: properties.fontFamily}}
                          variant="caption"
                          fontWeight="medium"
                        >
                          {details ? details.empId : "-"}
                        </Typography>
                      </Typography>
                    </MDBox>
                    <MDBox mb={1} lineHeight={0} ml={0}>
                      <Typography
                        variant="caption"
                        color="text"
                        mr={2}
                        fontFamily={properties.fontFamily}
                      >
                        Designation :&nbsp;
                        <Typography
                          sx={{width: "150px"}}
                          variant="outlined"
                          fontWeight="medium"
                          fontFamily={properties.fontFamily}
                        >
                          {details ? formatDesignation(details.designation) : " - "}
                        </Typography>
                      </Typography>
                    </MDBox>
                  </MDBox>
                  <MDBox
                    display="flex"
                    justifyContent="space-between"
                    alignItems={{xs: "flex-start", sm: "center"}}
                    flexDirection={{xs: "column", sm: "row"}}
                    mb={1}
                  >
                    <MDBox mb={1} lineHeight={0} ml={0}>
                      <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                        Official Email ID :&nbsp;
                        <Typography
                          sx={{width: "150px", fontFamily: properties.fontFamily}}
                          variant="caption"
                          fontWeight="medium"
                        >
                          {details ? details.officialEmailAddress : " - "}
                        </Typography>
                      </Typography>
                    </MDBox>
                    <MDBox mb={1} lineHeight={0} ml={0}>
                      <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                        Username :&nbsp;
                        <Typography
                          sx={{width: "150px", fontFamily: properties.fontFamily}}
                          variant="caption"
                          fontWeight="medium"
                        >
                          {details ? details.firstName + " " + details.lastName : " - "}
                        </Typography>
                      </Typography>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDBox>
              {/* </MDBox> */}
              <DataGrid
                rows={data}
                columns={columns}
                pagination={false}
                hideFooter={data?.length <= 20}
                hideFooterPagination={true}
                sx={{
                  fontFamily: properties.fontFamily,
                  fontSize: "14px"
                }}
              />
              <MDBox pt={2} pb={2} px={2}>
                <InputLabel
                  sx={{
                    fontWeight: "bold",
                    paddingBottom: "5px",
                    fontFamily: properties.fontFamily
                  }}
                >
                  Roster Details
                </InputLabel>

                <FormControl variant="standard" sx={{m: 1, width: "30ch"}}>
                  <InputLabel id="MasterTeam">
                    Master Team <span style={{color: properties.colors.Red}}>*</span>
                  </InputLabel>
                  <Select
                    required
                    value={formData ? formData.masterTeam : ""}
                    name="masterTeam"
                    label="Select Master Team "
                    onChange={e => handleChange(e)}
                    IconComponent={ExpandMoreIcon}
                  >
                    <MenuItem value="">
                      <em>Select</em>
                    </MenuItem>
                    <MenuItem value="1">CD-BANKING</MenuItem>
                    <MenuItem value="2">CD-ENTERPRISE</MenuItem>
                    <MenuItem value="3">CD-CALYPSO</MenuItem>
                    <MenuItem value="4">CD-ATLAS</MenuItem>
                    <MenuItem value="5">COMMHUB</MenuItem>
                  </Select>
                </FormControl>

                <FormControl variant="standard" sx={{m: 1, width: "30ch"}}>
                  <InputLabel id="subTeam">
                    Sub Team <span style={{color: properties.colors.Red}}>*</span>
                  </InputLabel>
                  <Select
                    value={formData ? formData.subTeam : ""}
                    name="subTeam"
                    label="Select Sub Team "
                    onChange={e => handleChange(e)}
                    IconComponent={ExpandMoreIcon}
                  >
                    <MenuItem value="">
                      <em>Select</em>
                    </MenuItem>
                    <MenuItem value="1">DEV</MenuItem>
                    <MenuItem value="2">QA</MenuItem>
                    <MenuItem value="9">WEB</MenuItem>
                    <MenuItem value="10">WEB QA</MenuItem>
                    <MenuItem value="11">ANDROID-DEV</MenuItem>
                    <MenuItem value="12">IOS-DEV</MenuItem>
                  </Select>
                </FormControl>

                <FormControl variant="standard" sx={{m: 1, width: "30ch"}}>
                  <InputLabel id="joinType">
                    Billing Status <span style={{color: properties.colors.Red}}>*</span>
                  </InputLabel>
                  <Select
                    value={formData ? formData.billableStatus : ""}
                    name="billableStatus"
                    label="Select Status *"
                    onChange={e => handleChange(e)}
                    IconComponent={ExpandMoreIcon}
                  >
                    <MenuItem value="">
                      <em>Select</em>
                    </MenuItem>
                    <MenuItem value="1">Billable</MenuItem>
                    <MenuItem value="0">Non Billable</MenuItem>
                  </Select>
                </FormControl>

                <FormControl variant="standard" sx={{m: 1, width: "30ch"}}>
                  <InputLabel id="localite">Localite</InputLabel>
                  <Select
                    value={formData ? formData.localite : ""}
                    name="localite"
                    label="Select"
                    onChange={e => handleChange(e)}
                    IconComponent={ExpandMoreIcon}
                  >
                    <MenuItem value="">
                      <em>Select</em>
                    </MenuItem>
                    <MenuItem value="Yes">Yes</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                  </Select>
                </FormControl>
              </MDBox>

              <MDBox mt={3} mb={2} sx={{display: "flex", justifyContent: "flex-end"}}>
                <MDBox sx={{display: "flex", gap: 1}}>
                  <MDButton
                    variant="gradient"
                    color="warning"
                    sx={{width: "20ch"}}
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </MDButton>
                  <MDButton
                    variant="gradient"
                    color="#fff"
                    sx={{
                      width: "20ch",
                      ml: 2,
                      mr: 2,
                      background: properties.colors.bgcolorbluethem
                    }}
                    onClick={() => handleSubmit()}
                    disabled={isSaveDisabled}
                  >
                    Save
                  </MDButton>
                </MDBox>
              </MDBox>

              <Snackbar
                open={open}
                anchorOrigin={{vertical: "top", horizontal: "right"}}
                autoHideDuration={2000}
                onClose={handleClose}
              >
                <Alert
                  onClose={handleClose}
                  severity={snakColor === "success" ? "success" : "error"}
                  variant="filled"
                  sx={{
                    backgroundColor:
                      snakColor === "success" ? "green" : snakColor === "error" ? "red" : "blue",
                    color: "white",
                    width: "100%"
                  }}
                >
                  {snakMessage}
                </Alert>
              </Snackbar>
            </MDBox>
          </Card>
        </AppBar>
      </MDBox>
    </DashboardLayout>
  );
}

export default AddToRoaster;
